import { render, staticRenderFns } from "./applyCertificate.vue?vue&type=template&id=3a9d211e&scoped=true&"
import script from "./applyCertificate.vue?vue&type=script&lang=js&"
export * from "./applyCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d211e",
  null
  
)

export default component.exports